module.exports = __webpack_public_path__ + "static/media/pyv-edit-delete-switch-to-manual-editor.f67c0083.gif";